import { SCALE_FACTOR as e } from "../../config/globalConstants.js";
import { createContext as t } from "react";
//#region src/components/Scale/ScaleContext.ts
var n = t({ scaleFactor: e });
//#endregion
export { n as ScaleContext };
